module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-cn/banner1-4247d8fbf1e63d161efc69c9d2efd5f7.jpg";